<template>
    <table class="table table-striped table-responsive-xl ">
        <thead>
            <tr>
                <th>Групи користувача</th>
            </tr>
        </thead>
        <tbody>
           <tr v-for="item of groups">
                <td>{{item.title}}</td>
           </tr>
        </tbody>
    </table>
</template>

<script>
    export default {

		name: "groups",
		props: {
			user_id: {
				type: Number,
				default: 0,
			}
		},
		data() {
			return {
				groups: {},
			}
		},

		created() {
			this.getUserData();
		},


		methods: {
			async getUserData() {
				await api.get('/user/' + this.user_id + "/groups").then(({data}) => {
					if (data.status === "operation_success") {
						this.groups = data.data;
					}
				}).catch(err => {
					console.log(err);
				});
			}
		}
	}
</script>

<style scope>

</style>
